
<div [class.vertical]="isVertical" [class.horizontal]="!isVertical" class="spash">
  <mat-spinner [diameter]="80" [strokeWidth]="3"  class="custom-spinner"></mat-spinner>
  <img src="assets/{{client}}/logo.svg" width="300" class="logomainspash"/>
</div>
